import { UPDATE_ISBOOKS, UPDATE_ISRM } from '../actions/bundleAccess';

const initialState = {
  isBooks: false,
  isRm: false,
};

export default function bundleAccessReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ISBOOKS:
      return {
        ...state,
        isBooks: action.payload,
      };
    case UPDATE_ISRM:
      return {
        ...state,
        isRm: action.payload,
      };

    default:
      return state;
  }
}
